import React from 'react'

const MoonFilledIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='11'
    height='11'
    viewBox='0 0 11 11'
    fill='none'
    {...props}
  >
    <path
      d='M5.40693 10.5C4.70693 10.5 4.05068 10.3667 3.43818 10.1C2.82568 9.83333 2.29235 9.47292 1.83818 9.01875C1.38402 8.56458 1.0236 8.03125 0.756934 7.41875C0.490267 6.80625 0.356934 6.15 0.356934 5.45C0.356934 4.23333 0.744434 3.16042 1.51943 2.23125C2.29443 1.30208 3.28193 0.725 4.48193 0.5C4.33193 1.325 4.37777 2.13125 4.61943 2.91875C4.8611 3.70625 5.27777 4.39583 5.86943 4.9875C6.4611 5.57917 7.15068 5.99583 7.93818 6.2375C8.72568 6.47917 9.53193 6.525 10.3569 6.375C10.1403 7.575 9.56527 8.5625 8.63193 9.3375C7.6986 10.1125 6.6236 10.5 5.40693 10.5Z'
      fill='currentColor'
    />
  </svg>
)

export default MoonFilledIcon
